export default "__VITE_ASSET__79de7600__"